import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalStore } from 'src/app/store/global-store';


@Component({
    selector: 'que-upload-file-admin',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateDirective, TranslatePipe],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UploadFileAdminComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UploadFileAdminComponent,
            multi: true
        }
    ],
    templateUrl: './upload-file-admin.component.html',
    styleUrls: ['./upload-file-admin.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileAdminComponent implements OnInit, ControlValueAccessor, Validator {
  #operationsStore = inject(MiniOperationsStore);
  @Input() index?: number;
  @Input()
  @Output() focusEvent = new EventEmitter<boolean>();

  #builder = inject(FormBuilder);
  questionForm = this.#builder.group({
    id: [-1],
    type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
    title: new FormControl<string>('', [Validators.required]),
    text: new FormControl<string>(''),
    imageBase64: new FormControl(''),
    additionalText: new FormControl(''),
    isUploadFile: new FormControl<boolean>(true),
    optionsList: new FormControl<OptionsList | null>(null,),
    requierd: new FormControl<boolean>(false),
    collectionQuestionId: new FormControl<number | null>(null),
    stepId: [-1],
  });
  orginalQuestion?:Question;
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({...this.orginalQuestion, ...question });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  // writeValue(obj: String[]): void {
  //   this.optionsValue.patchValue({ op1:obj[0],op2:obj[1] }, { emitEvent: false });
  //   //this.onValidationChangeCallBack();xxx
  // }
  writeValue(obj: Question): void {
    this.orginalQuestion=obj;
    this.questionForm.patchValue({ ...obj }, { emitEvent: false });
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }

  fileName?: string;
  selectedFileName: string | null = null;

  #questionnaireStore = inject(QuestionnaireStore);
  isRoleAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);

  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));

  onFileChange(input: HTMLInputElement): void {
    const file = input?.files?.[0];
    this.fileName = file?.name;
    this.questionForm.controls.additionalText.setValue(file?.name ?? "");
    if (file) {
      this.readFileAsBase64(file);
    }
  }
  readFileAsBase64(file: File): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Data = reader.result as string;
      this.questionForm.controls.imageBase64.setValue(base64Data);
      this.registerOnChangeCallback({ ...this.questionForm.value });
    };
    reader.readAsDataURL(file);
  }
  remove() {
    this.questionForm.controls.imageBase64.setValue(null);
    this.questionForm.controls.additionalText.setValue(null);
  }
  async filesDroped(file: any) {
    this.fileName = file?.name;
    if (file) {
      this.readFileAsBase64(file);
    }
  }
}

